export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const isFileWithinSizeLimit = (file: File | Blob, maxBytes: number = MAX_FILE_SIZE_BYTES) =>
  file.size <= maxBytes;

// For base64 (optionally data-URL-prefixed) strings from webcam captures
export const base64ByteLength = (base64: string) => {
  const clean = base64.includes(",") ? base64.split(",")[1] : base64;
  const padding = clean.endsWith("==") ? 2 : clean.endsWith("=") ? 1 : 0;
  return (clean.length * 3) / 4 - padding;
};

export const isBase64WithinSizeLimit = (base64: string, maxBytes: number = MAX_FILE_SIZE_BYTES) =>
  base64ByteLength(base64) <= maxBytes;

export const fileSizeErrorMessage = (name?: string) =>
  `${name ? `"${name}" exceeds` : "File exceeds"} the ${MAX_FILE_SIZE_MB}MB size limit. Please choose a smaller file.`;
